import VueRouter from 'vue-router';

// Vue Templates
import HomeNew from '@/views/HomeNew.vue';
import HomeB from '@/views/HomeB.vue';

const routes = [
    {
        path: '/',
        name: 'HomeNew',
        component: HomeNew,
    },
    {
        path: '/b',
        name: 'HomeB',
        component: HomeB,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
